export { extractFromPath, getObjFromQueryString } from './url.es.js';
export { PATTERN_VALIDATION, isValidEmailFormat, isValidPhoneFormat, isValidTaxCode } from './validators.es.js';
export { formatDate } from './date.es.js';
export { htmlDecode, htmlEncode } from './html.es.js';
export { isFloat, stringToInteger } from './number.es.js';
export { COOKIE_OVER_18_YEARS_OLD, getCookieOver18YearOld, setCookieOver18YearOld } from './storage.es.js';
export { cancelIdleCallback, requestIdleCallback, scheduleTaskInIdleTime } from './polyfill.es.js';
export { normalizeText, parseJsonStringSafely } from './string.es.js';
export { ConditionalWrapper, ConditionalWrapperUsingCallback } from './tsx.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const normalizePhone = (rawphone) => {
  const phone = rawphone.trim();
  if (phone.length > 10) {
    if (phone.startsWith("84"))
      return phone.replace("84", "0");
    if (phone.startsWith("+84"))
      return phone.replace("+84", "0");
    return phone;
  }
  return phone;
};
const customizedMessage = (message, fields) => {
  let resultMessage = message;
  fields.forEach(({ name, value }) => {
    const regex = new RegExp(`{${name}}`, "g");
    resultMessage = resultMessage.replace(regex, value);
  });
  return resultMessage;
};
const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
const toObject = (arr, keyField) => {
  let newArr = {};
  if (Array.isArray(arr)) {
    for (let i = 0; i < arr.length; i++) {
      const curr = arr[i];
      newArr = __spreadProps(__spreadValues({}, newArr), {
        [curr[keyField]]: curr
      });
    }
  }
  return newArr;
};
const cleanObject = (object) => {
  if (!object) {
    return object;
  }
  const newObj = {};
  const currentKeys = Object.keys(object);
  currentKeys.forEach((key) => {
    if (object[key] || object[key] === false || object[key] === 0) {
      newObj[key] = object[key];
    }
  });
  return newObj;
};
const formatCurrency = (money, isFull = true) => {
  return `${money || money == 0 ? money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : money}${isFull ? "\u0111" : ""}`;
};
function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
const roundQuantity = ({
  quantity,
  precision
}) => {
  return Math.round(quantity * Math.pow(10, precision)) / Math.pow(10, precision);
};

export { cleanObject, customizedMessage, debounce, formatCurrency, inIframe, normalizePhone, roundQuantity, toObject };
